import { NodeViewSettingsPanel } from '@/components/common/node-view-settings-panel';
import { CommonNodeViewWrapper, DEFAULT_CONTENT_CLASS } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';
import { Plus } from 'lucide-react';

const QuestionSetNodeView: React.FC<ReactNodeViewProps> = ({ node, selected, editor, updateAttributes, decorations }) => {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const { questionType } = node.attrs;
    const caption = node.attrs.caption || '';

    const handleCaptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateAttributes({ caption: e.target.value });
    };

    const getQuestionTypeLabel = () => {
        switch (questionType) {
            case 'multipleChoice':
                return 'Multiple Choice';
            case 'shortAnswer':
                return 'Short Answer';
            case 'matching':
                return 'Matching';
            case 'detectAnswer':
                return 'Detect Answer';
            default:
                return 'Activity';
        }
    };

    const buildQuestionSetFooter = () => {
        if (questionType === 'matching') {
            return null;
        }
        return (
            <div>
                <button
                    onClick={() => editor.commands.addQuestionSetQuestion(node)}
                    disabled={isEditorReadonly}
                    className="group mt-3 flex w-full items-center justify-center gap-2 rounded-lg border-2 border-gray-300 px-4 py-1 text-gray-500 transition-all duration-200 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:text-gray-400 dark:hover:border-blue-500 dark:hover:bg-blue-950/20 dark:hover:text-blue-400 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <Plus className="h-4 w-4" />
                    <span className="text-sm font-medium">Add Question</span>
                </button>
            </div>
        );
    };

    const mainContent = <NodeViewContent />;

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label={`${getQuestionTypeLabel()} Question Set`}
            selected={selected}
            contentClassName={`${DEFAULT_CONTENT_CLASS} pt-2`}
            settingsPanel={
                <NodeViewSettingsPanel
                    fields={[
                        {
                            label: 'Caption',
                            type: 'text',
                            value: caption,
                            onChange: handleCaptionChange,
                            placeholder: 'Caption...',
                            searchAttr: 'caption',
                        },
                    ]}
                />
            }
            fullscreenContent={mainContent}
            footer={buildQuestionSetFooter()}
            fullscreenMode="inline"
            contentHeightClassName=""
        >
            {mainContent}
        </CommonNodeViewWrapper>
    );
};

export default QuestionSetNodeView;
